import type { InferOutput } from "valibot";

export const socialMediaSchema = v.object({
  url: v.pipe(v.string(), v.url()),
  icon: v.string(),
});
export type SocialMedia = InferOutput<typeof socialMediaSchema>;
